import { getCommonFilterConfig } from '@bingads-webui-campaign/common-grid-config';
import { FilterPreferenceService } from '@bingads-webui-campaign-react/merchant-shared';
import { sessionStore } from '@bingads-webui/js-data-storage';
import myReportsSchema from './schema';

const schemaI18n = {
  property: (type, property) => property,
  value: (type, property, value) => value,
};

export function getFilterConfig({
  i18n,
}) {
  const filterConfig = getCommonFilterConfig({
    preferenceService: {},
    featureName: 'myReportsGrid',
    entitySchema: myReportsSchema({ i18n }),
    i18n,
    legacyGlobalI18n: i18n,
    sessionStore,
    preferenceStoreFactory: () => new FilterPreferenceService(),
    schemaI18nCampaign: schemaI18n,
    dataContextManager: {},
    jsdata: {},
    updatePilot: false,
    enableCampaignWaterfall: false,
    editor: {},
    searchbox: {
      placeholder: i18n.getString(_TL_('Report name')),
      searchProperty: 'Name',
      searchOperator: '$contains',
      ignoreCase: true,
    },
  });

  return filterConfig;
}
